var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1703 4.99875C10.3197 4.99824 10.4673 5.03121 10.6023 5.09524C10.7373 5.15927 10.8562 5.25273 10.9503 5.36875L15.7803 11.3687C15.9274 11.5477 16.0078 11.7721 16.0078 12.0037C16.0078 12.2354 15.9274 12.4598 15.7803 12.6387L10.7803 18.6387C10.6106 18.843 10.3667 18.9714 10.1022 18.9958C9.83782 19.0201 9.57454 18.9385 9.37032 18.7687C9.16611 18.599 9.03768 18.3551 9.0133 18.0907C8.98892 17.8262 9.07059 17.563 9.24032 17.3587L13.7103 11.9987L9.39033 6.63875C9.26804 6.49196 9.19037 6.31322 9.16649 6.12367C9.14261 5.93412 9.17352 5.7417 9.25558 5.56917C9.33764 5.39664 9.4674 5.25123 9.62951 5.15014C9.79162 5.04905 9.97929 4.99652 10.1703 4.99875Z",
    fill: "#1C1D21"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 7.5,
    transform: "rotate(-180 23.5 23.5)",
    stroke: "#1C1D21"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.081bab7822caf690d3689869f1352084.svg";
export { ForwardRef as ReactComponent };